import "core-js/modules/es.array.reverse.js";
var _class, _BingMapsSearchProvider;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
import i18next from "i18next";
import { makeObservable, override, runInAction } from "mobx";
import Rectangle from "terriajs-cesium/Source/Core/Rectangle";
import Resource from "terriajs-cesium/Source/Core/Resource";
import defined from "terriajs-cesium/Source/Core/defined";
import { Category, SearchAction } from "../../Core/AnalyticEvents/analyticEvents";
import loadJson from "../../Core/loadJson";
import { applyTranslationIfExists } from "../../Language/languageHelpers";
import LocationSearchProviderMixin, { getMapCenter } from "../../ModelMixins/SearchProviders/LocationSearchProviderMixin";
import BingMapsSearchProviderTraits from "../../Traits/SearchProviders/BingMapsSearchProviderTraits";
import CreateModel from "../Definition/CreateModel";
import CommonStrata from "./../Definition/CommonStrata";
import SearchResult from "./SearchResult";
let BingMapsSearchProvider = (_class = (_BingMapsSearchProvider = class BingMapsSearchProvider extends LocationSearchProviderMixin(CreateModel(BingMapsSearchProviderTraits)) {
  get type() {
    return BingMapsSearchProvider.type;
  }
  constructor(uniqueId, terria) {
    super(uniqueId, terria);
    makeObservable(this);
    runInAction(() => {
      if (this.terria.configParameters.bingMapsKey) {
        this.setTrait(CommonStrata.defaults, "key", this.terria.configParameters.bingMapsKey);
      }
    });
  }
  showWarning() {
    if (!this.key || this.key === "") {
      console.warn("The ".concat(applyTranslationIfExists(this.name, i18next), "(").concat(this.type, ") geocoder will always return no results because a Bing Maps key has not been provided. Please get a Bing Maps key from bingmapsportal.com and add it to parameters.bingMapsKey in config.json."));
    }
  }
  logEvent(searchText) {
    var _this$terria$analytic;
    (_this$terria$analytic = this.terria.analytics) === null || _this$terria$analytic === void 0 || _this$terria$analytic.logEvent(Category.search, SearchAction.bing, searchText);
  }
  doSearch(searchText, searchResults) {
    searchResults.results.length = 0;
    searchResults.message = undefined;
    const searchQuery = new Resource({
      url: this.url + "REST/v1/Locations",
      queryParameters: {
        culture: this.culture,
        query: searchText,
        key: this.key,
        maxResults: this.maxResults
      }
    });
    if (this.mapCenter) {
      const mapCenter = getMapCenter(this.terria);
      searchQuery.appendQueryParameters({
        userLocation: "".concat(mapCenter.latitude, ", ").concat(mapCenter.longitude)
      });
    }
    const promise = loadJson(searchQuery);
    return promise.then(result => {
      if (searchResults.isCanceled) {
        // A new search has superseded this one, so ignore the result.
        return;
      }
      if (result.resourceSets.length === 0) {
        searchResults.message = {
          content: "translate#viewModels.searchNoLocations"
        };
        return;
      }
      const resourceSet = result.resourceSets[0];
      if (resourceSet.resources.length === 0) {
        searchResults.message = {
          content: "translate#viewModels.searchNoLocations"
        };
        return;
      }
      runInAction(() => {
        const locations = this.sortByPriority(resourceSet.resources);
        searchResults.results.push(...locations.primaryCountry);
        searchResults.results.push(...locations.other);
      });
      if (searchResults.results.length === 0) {
        searchResults.message = {
          content: "translate#viewModels.searchNoLocations"
        };
      }
    }).catch(() => {
      if (searchResults.isCanceled) {
        // A new search has superseded this one, so ignore the result.
        return;
      }
      searchResults.message = {
        content: "translate#viewModels.searchErrorOccurred"
      };
    });
  }
  sortByPriority(resources) {
    const primaryCountryLocations = [];
    const otherLocations = [];

    // Locations in the primary country go on top, locations elsewhere go undernearth and we add
    // the country name to them.
    for (let i = 0; i < resources.length; ++i) {
      const resource = resources[i];
      let name = resource.name;
      if (!defined(name)) {
        continue;
      }
      let list = primaryCountryLocations;
      let isImportant = true;
      const country = resource.address ? resource.address.countryRegion : undefined;
      if (defined(this.primaryCountry) && country !== this.primaryCountry) {
        // Add this location to the list of other locations.
        list = otherLocations;
        isImportant = false;

        // Add the country to the name, if it's not already there.
        if (defined(country) && name.lastIndexOf(country) !== name.length - country.length) {
          name += ", " + country;
        }
      }
      list.push(new SearchResult({
        name: name,
        isImportant: isImportant,
        clickAction: createZoomToFunction(this, resource),
        location: {
          latitude: resource.point.coordinates[0],
          longitude: resource.point.coordinates[1]
        }
      }));
    }
    return {
      primaryCountry: primaryCountryLocations,
      other: otherLocations
    };
  }
}, _defineProperty(_BingMapsSearchProvider, "type", "bing-maps-search-provider"), _BingMapsSearchProvider), _applyDecoratedDescriptor(_class.prototype, "showWarning", [override], Object.getOwnPropertyDescriptor(_class.prototype, "showWarning"), _class.prototype), _class);
export { BingMapsSearchProvider as default };
function createZoomToFunction(model, resource) {
  const [south, west, north, east] = resource.bbox;
  const rectangle = Rectangle.fromDegrees(west, south, east, north);
  return function () {
    const terria = model.terria;
    terria.currentViewer.zoomTo(rectangle, model.flightDurationSeconds);
  };
}